export default __webpack_public_path__ + "static/media/02.0699e968.jpg";